import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RootLayout } from '../root/root.component';


@Component({
  selector: 'corporate-layout',
  templateUrl: './corporate.component.html',
  styleUrls: ['./corporate.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CorporateLayout extends RootLayout implements OnInit {
  menuLinks = [
    {
      label: "Dashboard",
      // details: "12 New Updates",
      routerLink: "dashboard",
      iconType: "pg",
      iconName: "home",
    },
    {
      label: "Users",
      // details: "12 New Updates",
      routerLink: "users",
      iconType: "fa",
      iconName: "user",
    },
    {
      label: "Courses",
      // details: "12 New Updates",
      routerLink: "courses",
      iconType: "fa",
      iconName: "newspaper-o",
    },
    {
      label: "App Management",
      // details: "12 New Updates",
      routerLink: "app_management",
      iconType: "pg",
      iconName: "settings_small",
    },
    {
      label: "Billing",
      // details: "12 New Updates",
      routerLink: "billing",
      iconType: "fa",
      iconName: "money",
    },
  ];

  ngOnInit() {
    this.changeLayout("menu-pin");
    this.changeLayout("menu-behind");
    //Will sidebar close on screens below 1024
    this.autoHideMenuPin();
  }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/layouts/corporate/corporate.component.ts